import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sendSubmission } from '../../../../api/submissions/sendSubmission';
import { toast } from 'react-toastify';
import renderToastError from '../../../../utils/renderToastError';
import type { AxiosError } from 'axios';
import useSession from '../../../../hooks/useSession';

export function useSubmitMutation() {
    const queryClient = useQueryClient();
    const session = useSession();

    return useMutation({
        mutationFn: sendSubmission,
        onMutate: () => toast.loading('Submitting...'),
        onSuccess: (data, submission, toastId) => {
            const userID = submission.userID ?? session.user?.ID;
            if (data.wasAuto) {
                void queryClient.invalidateQueries({ queryKey: ['level', submission.levelID] });
                void queryClient.invalidateQueries({ queryKey: ['submission', submission.levelID, userID] });
                if (userID !== undefined) void queryClient.invalidateQueries({ queryKey: ['user', userID] });
            }
            toast.update(toastId, {
                render: data.wasAuto ? 'Submission accepted' : 'Submission queued',
                isLoading: false,
                autoClose: 5000,
                type: data.wasAuto ? 'success' : 'info',
            });
        },
        onError: (error: AxiosError, _, toastId) => renderToastError.error(toastId!, error),
    });
}
